var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Country/liechtenstein") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Country/liechtenstein",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "liechtenstein",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512,256 C512,397.384 397.384,512 256,512 C114.616,512 0,397.384 0,256 C11.13,256 256,222.609 256,222.609 L512,256 Z",
    id: "Path",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,256 C0,114.616 114.616,0 256,0 C397.384,0 512,114.616 512,256",
    id: "Path",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.217,178.087 C189.217,159.646 174.267,144.696 155.826,144.696 C147.271,144.696 139.474,147.916 133.565,153.205 L133.565,133.565 L144.695,133.565 L144.695,111.304 L133.565,111.304 L133.565,100.174 L111.304,100.174 L111.304,111.304 L100.174,111.304 L100.174,133.565 L111.304,133.565 L111.304,153.205 C105.395,147.916 97.598,144.696 89.043,144.696 C70.602,144.696 55.652,159.646 55.652,178.087 C55.652,187.974 59.953,196.854 66.782,202.969 L66.782,222.609 L178.086,222.609 L178.086,202.969 C184.917,196.854 189.217,187.974 189.217,178.087 Z",
    id: "Path",
    fill: "#FFDA44"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLi);
export default __webpack_public_path__ + "static/media/LI.caaa99a7be4f6c32518f13e2cde1a1cb.svg";
export { ForwardRef as ReactComponent };